import React from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { freeBetStore } from '../../../../store/freeBetStore';

import FreeBetTotalWin from './freeBetTotalWin';
import FreeBetAwardCount from './freeBetAwardCount';

const FreeBetContent = observer(() => {
  const { isFreeBetEnd } = freeBetStore;

  return (
    <Container x={248} y={160} name='FreeBetContentContainer'>
      {isFreeBetEnd ? <FreeBetTotalWin /> : <FreeBetAwardCount />}
    </Container>
  );
});

export default FreeBetContent;
